import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { reduce, find, filter } from 'lodash';
import { connect } from 'react-redux';
import Fa from 'react-fontawesome';
import { Button, Modal } from 'react-bootstrap';
import ProgressBar from '../../../../components/progress-bar';
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import { requestFetchUserTypes, requestUpdateUserTypes } from '../../SetupActions';


class UserTypeSettings extends Component {
  constructor() {
    super();
    this.state = {
      loading: true,
      loaded: false,
      types: [],
      error: null,
      dirty: false,
      updating: false,
      openModal: false,
    };
    this.toggleType = this.toggleType.bind(this);
    this.submit = this.submit.bind(this);
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  calibrateTypes(types) {
    return reduce(types, (items, type) => {
      items.push({
        ...type,
        _excluded: type.excluded, // store old value
      });
      return items;
    }, []);
  }

  openModal() {
    this.setState({ openModal: true });
  }

  closeModal() {
    this.setState({ openModal: false });
  }

  submit() {
    if (this.state.updating) {
      return;
    }
    this.setState({ updating: true }, () => {
      const { types } = this.state;
      const values = reduce(types, (items, type) => {
        if (type.excluded) {
          items.push(type.value);
        }
        return items;
      }, []);
      this.props.dispatch(requestUpdateUserTypes({
        exclude_user_types: values
      }))
        .then(
          (results) => {
            this.setState({
              dirty: false,
              updating: false,
              openModal: false,
              types: this.calibrateTypes(results),
            });
          },
          () => {
            // TODO:
          },
        );
    });
  }

  toggleType(value) {
    const { types } = this.state;
    const newTypes = reduce(types, (items, type) => {
      items.push({
        ...type,
        excluded: value === type.value ? !type.excluded : type.excluded,
      });
      return items;
    }, []);
    const dirty = find(newTypes, (t) => {
      return t._excluded !== t.excluded;
    }) !== undefined;

    this.setState({ types: newTypes, dirty });
  }

  loadData() {
    this.setState({ loading: true, loaded: false, error: null, dirty: false }, () => {
      this.props.dispatch(requestFetchUserTypes())
        .then(
          (types) => {
            this.setState({
              types: this.calibrateTypes(types),
              loading: false,
              loaded: true,
            });
          },
          (e) => {
            this.setState({
              error: e?.data?.message || e?.data,
              loading: false,
              loaded: true,
            });
          },
        );
    });
  }

  renderModal() {
      const { openModal } = this.state;
      return (
        <Modal show={openModal} onHide={this.closeModal}>
          <Modal.Header closeButton>
            <h4>Sync User Types</h4>
          </Modal.Header>
          <Modal.Body>
            <div className="well well-xs">
            Select the user type(s) that will be excluded from the data sync.
            </div>
            {this.renderList()}
          </Modal.Body>
        </Modal>
      );
    }

  renderAnchor() {
    const { types } = this.state;
    const excluded = filter(types, { _excluded: true });
    let text = null;

    if (excluded.length === 0) {
      text = 'TruVoice Automation will sync all users from the CRM';
    } else if (excluded.length === 1) {
      text = (
        <span>
          <Fa name="exclamation-triangle" className="text-warning" /> Users of type <code>{excluded[0].label}</code> will be excluded from the sync
        </span>
      );
    } else {
      const total = excluded.length;

      text = (
        <span>
          <Fa name="exclamation-triangle" className="text-warning" /> These users will be excluded from the sync: {excluded.map((t, i) => {
            return [
              (<code key={`main-${t.value}`}>{t.label}</code>),
              ...(i < total - 2 ? [<span key={`comma-${t.value}`}>, </span>] : []),
              ...(i === total - 2 ? [<span key={`comma-${t.value}`}> and </span>] : []),
            ];
          })}
        </span>
      );
    }


    return (
      <div>
        {text}
        {' '}
        <Button bsSize="xs" bsStyle="default" onClick={this.openModal}><Fa name="edit" /> Edit</Button>
      </div>
    );
  }

  renderList() {
    const { types, dirty, updating } = this.state;
    if (types.length === 0) {
      return (
        <div className="alert alert-danger">No user types found.</div>
      );
    }
    return (
      <div>
        <table className="table table-hover table-striped">
          <thead>
            <tr>
              <th width="100%">User Type</th>
              <th width="100">API Value</th>
              <th width="100">Sync</th>
            </tr>
          </thead>
          <tbody>
            {types.map((type) => {
              const synced = type.excluded !== true;
              const isStandard = type.value === 'Standard';
              let cursor = null;
              let faCls = synced ? 'text-active' : '';
              if (isStandard) {
                cursor = 'not-allowed';
                faCls = 'text-success';
              } else {
                cursor = 'pointer';
              }
              
              return (
                <tr key={type.value}>
                  <td style={{ fontWeight: synced ? 'bold' : '' }}>{type.label}</td>
                  <td><code>{type.value}</code></td>
                  <td style={{ cursor }} onClick={isStandard ? () => {} : () => {
                    this.toggleType(type.value);
                  }}>
                    <Fa className={faCls} name={synced ? 'check-square' : 'square-o'} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
        <div className="text-right">
          <Button onClick={this.submit} bsStyle="primary" disabled={(!dirty || updating)}>
            Update {updating && <Fa name="spinner" spin />}
          </Button>
        </div>
      </div>
    );
  }

  render() {
    const { loading, loaded } = this.state;
    const { isModal } = this.props;
    if (loading) {
      return (<div><ProgressBar /></div>);
    }
    return (
      <div>
        {loaded && isModal && this.renderAnchor()}
        {loaded && !isModal && this.renderList()}
        {loaded && isModal && this.renderModal()}
        <p />
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

UserTypeSettings.propTypes = {
  dispatch: PropTypes.func.isRequired,
  organization: PropTypes.shape({}).isRequired,
  isModal: PropTypes.bool,
};


UserTypeSettings.defaultProps = {
  isModal: false,
};

UserTypeSettings.contextTypes = {
};

export default connect(mapStateToProps)(UserTypeSettings);
